import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Short` scalar type represents non-fractional signed whole 16-bit numeric values. Short can represent values between -(2^15) and 2^15 - 1. */
  Short: any;
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
};

export type Query = {
  __typename?: 'Query';
  auctions: Array<Auction>;
  averagePrice: Array<AveragePrice>;
  bidScore?: Maybe<Scalars['Float']>;
  colors: Array<Scalars['String']>;
  companies: Array<Company>;
  frames: Array<Frame>;
  lot?: Maybe<JpcenterAuctLotsFull3>;
  lotsPaginatedList?: Maybe<LotsPaginatedListCollectionSegment>;
  models: Array<Model>;
  scores: Array<Scalars['String']>;
  transmissions: Array<Scalars['String']>;
  years: Array<Scalars['Int']>;
};


export type QueryAuctionsArgs = {
  order?: Maybe<Array<JpcenterAuctLotsFull3SortInput>>;
  where?: Maybe<JpcenterAuctLotsFull3FilterInput>;
};


export type QueryAveragePriceArgs = {
  companyEn: Scalars['String'];
  modelEn: Scalars['String'];
  modelTypeEn?: Maybe<Scalars['String']>;
  subgroup: Scalars['String'];
};


export type QueryBidScoreArgs = {
  amount: Scalars['Long'];
  companyEn: Scalars['String'];
  mileage: Scalars['Long'];
  modelEn: Scalars['String'];
  modelTypeEn?: Maybe<Scalars['String']>;
  ratingEn: Scalars['String'];
  year: Scalars['Int'];
};


export type QueryColorsArgs = {
  order?: Maybe<Array<JpcenterAuctLotsFull3SortInput>>;
  where?: Maybe<JpcenterAuctLotsFull3FilterInput>;
};


export type QueryCompaniesArgs = {
  order?: Maybe<Array<JpcenterAuctLotsFull3SortInput>>;
  where?: Maybe<JpcenterAuctLotsFull3FilterInput>;
};


export type QueryFramesArgs = {
  order?: Maybe<Array<JpcenterAuctLotsFull3SortInput>>;
  where?: Maybe<JpcenterAuctLotsFull3FilterInput>;
};


export type QueryLotArgs = {
  id: Scalars['String'];
};


export type QueryLotsPaginatedListArgs = {
  order?: Maybe<Array<JpcenterAuctLotsFull3SortInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<JpcenterAuctLotsFull3FilterInput>;
};


export type QueryModelsArgs = {
  order?: Maybe<Array<JpcenterAuctLotsFull3SortInput>>;
  where?: Maybe<JpcenterAuctLotsFull3FilterInput>;
};


export type QueryScoresArgs = {
  order?: Maybe<Array<JpcenterAuctLotsFull3SortInput>>;
  where?: Maybe<JpcenterAuctLotsFull3FilterInput>;
};


export type QueryTransmissionsArgs = {
  order?: Maybe<Array<JpcenterAuctLotsFull3SortInput>>;
  where?: Maybe<JpcenterAuctLotsFull3FilterInput>;
};


export type QueryYearsArgs = {
  order?: Maybe<Array<JpcenterAuctLotsFull3SortInput>>;
  where?: Maybe<JpcenterAuctLotsFull3FilterInput>;
};

export type JpcenterAuctLotsFull3SortInput = {
  auctionName?: Maybe<SortEnumType>;
  auctRef?: Maybe<SortEnumType>;
  awdNum?: Maybe<SortEnumType>;
  bid?: Maybe<SortEnumType>;
  color?: Maybe<SortEnumType>;
  colorEn?: Maybe<SortEnumType>;
  colorRef?: Maybe<SortEnumType>;
  company?: Maybe<SortEnumType>;
  companyEn?: Maybe<SortEnumType>;
  companyRef?: Maybe<SortEnumType>;
  date?: Maybe<SortEnumType>;
  datetime?: Maybe<SortEnumType>;
  displacedDatetime?: Maybe<SortEnumType>;
  displacement?: Maybe<SortEnumType>;
  displacementNum?: Maybe<SortEnumType>;
  downloadTime?: Maybe<SortEnumType>;
  endPrice?: Maybe<SortEnumType>;
  endPriceNum?: Maybe<SortEnumType>;
  equipment?: Maybe<SortEnumType>;
  equipmentEn?: Maybe<SortEnumType>;
  gradeEn?: Maybe<SortEnumType>;
  inspection?: Maybe<SortEnumType>;
  inspectionEn?: Maybe<SortEnumType>;
  isSpecial?: Maybe<SortEnumType>;
  lotId?: Maybe<SortEnumType>;
  mileage?: Maybe<SortEnumType>;
  mileageEn?: Maybe<SortEnumType>;
  mileageNum?: Maybe<SortEnumType>;
  modelDetailsEn?: Maybe<SortEnumType>;
  modelGradeEn?: Maybe<SortEnumType>;
  modelName?: Maybe<SortEnumType>;
  modelNameEn?: Maybe<SortEnumType>;
  modelNameRef?: Maybe<SortEnumType>;
  modelType?: Maybe<SortEnumType>;
  modelTypeEn?: Maybe<SortEnumType>;
  modelYear?: Maybe<SortEnumType>;
  modelYearEn?: Maybe<SortEnumType>;
  parsedData?: Maybe<SortEnumType>;
  parsedDataEn?: Maybe<SortEnumType>;
  parsedDataRu?: Maybe<SortEnumType>;
  picsDownloaded?: Maybe<SortEnumType>;
  pictures?: Maybe<SortEnumType>;
  result?: Maybe<SortEnumType>;
  resultRef?: Maybe<SortEnumType>;
  scores?: Maybe<SortEnumType>;
  scoresEn?: Maybe<SortEnumType>;
  serviceData?: Maybe<SortEnumType>;
  startPrice?: Maybe<SortEnumType>;
  startPriceNum?: Maybe<SortEnumType>;
  swType?: Maybe<SortEnumType>;
  transmission?: Maybe<SortEnumType>;
  transmissionEn?: Maybe<SortEnumType>;
  truckRef?: Maybe<SortEnumType>;
  vin?: Maybe<SortEnumType>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type JpcenterAuctLotsFull3FilterInput = {
  and?: Maybe<Array<JpcenterAuctLotsFull3FilterInput>>;
  auctionName?: Maybe<StringOperationFilterInput>;
  auctRef?: Maybe<IntOperationFilterInput>;
  awdNum?: Maybe<ShortOperationFilterInput>;
  bid?: Maybe<StringOperationFilterInput>;
  color?: Maybe<StringOperationFilterInput>;
  colorEn?: Maybe<StringOperationFilterInput>;
  colorRef?: Maybe<IntOperationFilterInput>;
  company?: Maybe<StringOperationFilterInput>;
  companyEn?: Maybe<StringOperationFilterInput>;
  companyRef?: Maybe<IntOperationFilterInput>;
  date?: Maybe<DateOperationFilterInput>;
  datetime?: Maybe<DateTimeOperationFilterInput>;
  displacedDatetime?: Maybe<DateTimeOperationFilterInput>;
  displacement?: Maybe<StringOperationFilterInput>;
  displacementNum?: Maybe<IntOperationFilterInput>;
  downloadTime?: Maybe<LongOperationFilterInput>;
  endPrice?: Maybe<StringOperationFilterInput>;
  endPriceNum?: Maybe<IntOperationFilterInput>;
  equipment?: Maybe<StringOperationFilterInput>;
  equipmentEn?: Maybe<StringOperationFilterInput>;
  gradeEn?: Maybe<StringOperationFilterInput>;
  inspection?: Maybe<StringOperationFilterInput>;
  inspectionEn?: Maybe<StringOperationFilterInput>;
  isSpecial?: Maybe<ShortOperationFilterInput>;
  lotId?: Maybe<StringOperationFilterInput>;
  mileage?: Maybe<StringOperationFilterInput>;
  mileageEn?: Maybe<StringOperationFilterInput>;
  mileageNum?: Maybe<IntOperationFilterInput>;
  modelDetailsEn?: Maybe<StringOperationFilterInput>;
  modelGradeEn?: Maybe<StringOperationFilterInput>;
  modelName?: Maybe<StringOperationFilterInput>;
  modelNameEn?: Maybe<StringOperationFilterInput>;
  modelNameRef?: Maybe<IntOperationFilterInput>;
  modelType?: Maybe<StringOperationFilterInput>;
  modelTypeEn?: Maybe<StringOperationFilterInput>;
  modelYear?: Maybe<StringOperationFilterInput>;
  modelYearEn?: Maybe<IntOperationFilterInput>;
  or?: Maybe<Array<JpcenterAuctLotsFull3FilterInput>>;
  parsedData?: Maybe<StringOperationFilterInput>;
  parsedDataEn?: Maybe<StringOperationFilterInput>;
  parsedDataRu?: Maybe<StringOperationFilterInput>;
  picsDownloaded?: Maybe<IntOperationFilterInput>;
  pictures?: Maybe<StringOperationFilterInput>;
  result?: Maybe<StringOperationFilterInput>;
  resultRef?: Maybe<IntOperationFilterInput>;
  scores?: Maybe<StringOperationFilterInput>;
  scoresEn?: Maybe<StringOperationFilterInput>;
  serviceData?: Maybe<StringOperationFilterInput>;
  startPrice?: Maybe<StringOperationFilterInput>;
  startPriceNum?: Maybe<IntOperationFilterInput>;
  swType?: Maybe<StringOperationFilterInput>;
  transmission?: Maybe<StringOperationFilterInput>;
  transmissionEn?: Maybe<StringOperationFilterInput>;
  truckRef?: Maybe<ShortOperationFilterInput>;
  vin?: Maybe<StringOperationFilterInput>;
};

export type StringOperationFilterInput = {
  and?: Maybe<Array<StringOperationFilterInput>>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  ncontains?: Maybe<Scalars['String']>;
  nendsWith?: Maybe<Scalars['String']>;
  neq?: Maybe<Scalars['String']>;
  nin?: Maybe<Array<Maybe<Scalars['String']>>>;
  nstartsWith?: Maybe<Scalars['String']>;
  or?: Maybe<Array<StringOperationFilterInput>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type IntOperationFilterInput = {
  eq?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  neq?: Maybe<Scalars['Int']>;
  ngt?: Maybe<Scalars['Int']>;
  ngte?: Maybe<Scalars['Int']>;
  nin?: Maybe<Array<Maybe<Scalars['Int']>>>;
  nlt?: Maybe<Scalars['Int']>;
  nlte?: Maybe<Scalars['Int']>;
};

export type ShortOperationFilterInput = {
  eq?: Maybe<Scalars['Short']>;
  gt?: Maybe<Scalars['Short']>;
  gte?: Maybe<Scalars['Short']>;
  in?: Maybe<Array<Maybe<Scalars['Short']>>>;
  lt?: Maybe<Scalars['Short']>;
  lte?: Maybe<Scalars['Short']>;
  neq?: Maybe<Scalars['Short']>;
  ngt?: Maybe<Scalars['Short']>;
  ngte?: Maybe<Scalars['Short']>;
  nin?: Maybe<Array<Maybe<Scalars['Short']>>>;
  nlt?: Maybe<Scalars['Short']>;
  nlte?: Maybe<Scalars['Short']>;
};

export type DateOperationFilterInput = {
  eq?: Maybe<Scalars['Date']>;
  gt?: Maybe<Scalars['Date']>;
  gte?: Maybe<Scalars['Date']>;
  in?: Maybe<Array<Maybe<Scalars['Date']>>>;
  lt?: Maybe<Scalars['Date']>;
  lte?: Maybe<Scalars['Date']>;
  neq?: Maybe<Scalars['Date']>;
  ngt?: Maybe<Scalars['Date']>;
  ngte?: Maybe<Scalars['Date']>;
  nin?: Maybe<Array<Maybe<Scalars['Date']>>>;
  nlt?: Maybe<Scalars['Date']>;
  nlte?: Maybe<Scalars['Date']>;
};

export type DateTimeOperationFilterInput = {
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
  ngt?: Maybe<Scalars['DateTime']>;
  ngte?: Maybe<Scalars['DateTime']>;
  nin?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  nlt?: Maybe<Scalars['DateTime']>;
  nlte?: Maybe<Scalars['DateTime']>;
};

export type LongOperationFilterInput = {
  eq?: Maybe<Scalars['Long']>;
  gt?: Maybe<Scalars['Long']>;
  gte?: Maybe<Scalars['Long']>;
  in?: Maybe<Array<Maybe<Scalars['Long']>>>;
  lt?: Maybe<Scalars['Long']>;
  lte?: Maybe<Scalars['Long']>;
  neq?: Maybe<Scalars['Long']>;
  ngt?: Maybe<Scalars['Long']>;
  ngte?: Maybe<Scalars['Long']>;
  nin?: Maybe<Array<Maybe<Scalars['Long']>>>;
  nlt?: Maybe<Scalars['Long']>;
  nlte?: Maybe<Scalars['Long']>;
};

export type Auction = {
  __typename?: 'Auction';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type AveragePrice = {
  __typename?: 'AveragePrice';
  avg: Scalars['Int'];
  count: Scalars['Int'];
  max: Scalars['Int'];
  mileageInterval?: Maybe<Scalars['Int']>;
  min: Scalars['Int'];
  score?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type Company = {
  __typename?: 'Company';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Frame = {
  __typename?: 'Frame';
  count: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type JpcenterAuctLotsFull3 = {
  __typename?: 'JpcenterAuctLotsFull3';
  auctionName: Scalars['String'];
  auctRef?: Maybe<Scalars['Int']>;
  awdNum?: Maybe<Scalars['Short']>;
  bid: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  colorEn?: Maybe<Scalars['String']>;
  colorRef?: Maybe<Scalars['Int']>;
  company?: Maybe<Scalars['String']>;
  companyEn?: Maybe<Scalars['String']>;
  companyRef?: Maybe<Scalars['Int']>;
  date: Scalars['Date'];
  datetime?: Maybe<Scalars['DateTime']>;
  displacedDatetime?: Maybe<Scalars['DateTime']>;
  displacement?: Maybe<Scalars['String']>;
  displacementNum?: Maybe<Scalars['Int']>;
  downloadTime?: Maybe<Scalars['Long']>;
  endPrice?: Maybe<Scalars['String']>;
  endPriceNum?: Maybe<Scalars['Int']>;
  equipment?: Maybe<Scalars['String']>;
  equipmentEn?: Maybe<Scalars['String']>;
  gradeEn?: Maybe<Scalars['String']>;
  inspection?: Maybe<Scalars['String']>;
  inspectionEn?: Maybe<Scalars['String']>;
  isSpecial: Scalars['Short'];
  lotId?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['String']>;
  mileageEn?: Maybe<Scalars['String']>;
  mileageNum?: Maybe<Scalars['Int']>;
  modelDetailsEn?: Maybe<Scalars['String']>;
  modelGradeEn?: Maybe<Scalars['String']>;
  modelName: Scalars['String'];
  modelNameEn?: Maybe<Scalars['String']>;
  modelNameRef?: Maybe<Scalars['Int']>;
  modelType?: Maybe<Scalars['String']>;
  modelTypeEn?: Maybe<Scalars['String']>;
  modelYear?: Maybe<Scalars['String']>;
  modelYearEn: Scalars['Int'];
  parsedData?: Maybe<Scalars['String']>;
  parsedDataEn?: Maybe<Scalars['String']>;
  parsedDataRu?: Maybe<Scalars['String']>;
  picsDownloaded: Scalars['Int'];
  pictures?: Maybe<Scalars['String']>;
  result: Scalars['String'];
  resultRef?: Maybe<Scalars['Int']>;
  scores?: Maybe<Scalars['String']>;
  scoresEn?: Maybe<Scalars['String']>;
  serviceData?: Maybe<Scalars['String']>;
  startPrice?: Maybe<Scalars['String']>;
  startPriceNum?: Maybe<Scalars['Int']>;
  swType?: Maybe<Scalars['String']>;
  transmission?: Maybe<Scalars['String']>;
  transmissionEn?: Maybe<Scalars['String']>;
  truckRef?: Maybe<Scalars['Short']>;
  vin?: Maybe<Scalars['String']>;
};

/** A segment of a collection. */
export type LotsPaginatedListCollectionSegment = {
  __typename?: 'LotsPaginatedListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<JpcenterAuctLotsFull3>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type Model = {
  __typename?: 'Model';
  companyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lotsCount: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type AveragePriceByRatingQueryVariables = Exact<{
  companyEn: Scalars['String'];
  modelEn: Scalars['String'];
  modelTypeEn?: Maybe<Scalars['String']>;
}>;


export type AveragePriceByRatingQuery = { __typename?: 'Query', averagePriceByRating: Array<{ __typename?: 'AveragePrice', avg: number, min: number, max: number, count: number, score?: Maybe<string>, year?: Maybe<number>, mileageInterval?: Maybe<number> }> };

export type JpCenterAutoLotQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type JpCenterAutoLotQuery = { __typename?: 'Query', lot?: Maybe<{ __typename?: 'JpcenterAuctLotsFull3', lotId?: Maybe<string>, bid: string, vin?: Maybe<string>, date: any, auctionName: string, truckRef?: Maybe<any>, result: string, companyRef?: Maybe<number>, modelNameRef?: Maybe<number>, transmissionEn?: Maybe<string>, inspection?: Maybe<string>, inspectionEn?: Maybe<string>, parsedData?: Maybe<string>, parsedDataEn?: Maybe<string>, parsedDataRu?: Maybe<string>, time?: Maybe<any>, company?: Maybe<string>, modelName?: Maybe<string>, modelGrade?: Maybe<string>, year: number, frame?: Maybe<string>, engineVolume?: Maybe<number>, equip?: Maybe<string>, color?: Maybe<string>, mileage?: Maybe<string>, rate?: Maybe<string>, startPrice?: Maybe<number>, finishPrice?: Maybe<number>, images?: Maybe<string> }> };

export type JpCenterLotsListFiltersQueryVariables = Exact<{
  withModel: Scalars['Boolean'];
  filter?: Maybe<JpcenterAuctLotsFull3FilterInput>;
  sort?: Maybe<Array<JpcenterAuctLotsFull3SortInput> | JpcenterAuctLotsFull3SortInput>;
}>;


export type JpCenterLotsListFiltersQuery = { __typename?: 'Query', colors?: Maybe<Array<string>>, scores: Array<string>, transmissions: Array<string>, frames?: Maybe<Array<{ __typename?: 'Frame', name?: Maybe<string>, count: number }>>, auctions: Array<{ __typename?: 'Auction', id?: Maybe<number>, name?: Maybe<string> }>, companies: Array<{ __typename?: 'Company', id?: Maybe<number>, name?: Maybe<string> }>, models: Array<{ __typename?: 'Model', id?: Maybe<number>, name?: Maybe<string>, companyId?: Maybe<number>, lotsCount: number }> };

export type JpCenterLotsListQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<JpcenterAuctLotsFull3FilterInput>;
  sort?: Maybe<Array<JpcenterAuctLotsFull3SortInput> | JpcenterAuctLotsFull3SortInput>;
}>;


export type JpCenterLotsListQuery = { __typename?: 'Query', lots?: Maybe<{ __typename?: 'LotsPaginatedListCollectionSegment', totalCount: number, items?: Maybe<Array<{ __typename?: 'JpcenterAuctLotsFull3', lotId?: Maybe<string>, bid: string, date: any, auctionName: string, truckRef?: Maybe<any>, result: string, companyEn?: Maybe<string>, modelNameEn?: Maybe<string>, colorEn?: Maybe<string>, transmissionEn?: Maybe<string>, time?: Maybe<any>, modelGrade?: Maybe<string>, year: number, frame?: Maybe<string>, engineVolume?: Maybe<number>, equip?: Maybe<string>, mileage?: Maybe<string>, rate?: Maybe<string>, startPrice?: Maybe<number>, finishPrice?: Maybe<number>, images?: Maybe<string> }>> }> };

export type LotsQueryVariables = Exact<{
  companyEn: Scalars['String'];
  modelEn: Scalars['String'];
  modelTypeEn?: Maybe<Scalars['String']>;
  filter?: Maybe<JpcenterAuctLotsFull3FilterInput>;
  subgroupByRating: Scalars['String'];
  subgroupByYear: Scalars['String'];
}>;


export type LotsQuery = { __typename?: 'Query', years: Array<number>, scores: Array<string>, averagePriceByRating: Array<{ __typename?: 'AveragePrice', avg: number, min: number, max: number, count: number, score?: Maybe<string>, year?: Maybe<number>, mileageInterval?: Maybe<number> }>, averagePriceByYear: Array<{ __typename?: 'AveragePrice', avg: number, min: number, max: number, count: number, score?: Maybe<string>, year?: Maybe<number> }>, frames: Array<{ __typename?: 'Frame', name?: Maybe<string> }>, lotsPaginatedList?: Maybe<{ __typename?: 'LotsPaginatedListCollectionSegment', items?: Maybe<Array<{ __typename?: 'JpcenterAuctLotsFull3', lotId?: Maybe<string>, date: any, bid: string, auctRef?: Maybe<number>, auctionName: string, datetime?: Maybe<any>, company?: Maybe<string>, companyEn?: Maybe<string>, companyRef?: Maybe<number>, modelNameEn?: Maybe<string>, modelNameRef?: Maybe<number>, modelYear?: Maybe<string>, modelYearEn: number, modelDetailsEn?: Maybe<string>, gradeEn?: Maybe<string>, modelGradeEn?: Maybe<string>, modelType?: Maybe<string>, modelTypeEn?: Maybe<string>, mileage?: Maybe<string>, mileageEn?: Maybe<string>, mileageNum?: Maybe<number>, inspection?: Maybe<string>, inspectionEn?: Maybe<string>, equipment?: Maybe<string>, equipmentEn?: Maybe<string>, transmission?: Maybe<string>, transmissionEn?: Maybe<string>, awdNum?: Maybe<any>, swType?: Maybe<string>, truckRef?: Maybe<any>, isSpecial: any, displacement?: Maybe<string>, displacementNum?: Maybe<number>, startPrice?: Maybe<string>, startPriceNum?: Maybe<number>, endPrice?: Maybe<string>, endPriceNum?: Maybe<number>, color?: Maybe<string>, colorEn?: Maybe<string>, colorRef?: Maybe<number>, scores?: Maybe<string>, scoresEn?: Maybe<string>, result: string, resultRef?: Maybe<number>, vin?: Maybe<string>, pictures?: Maybe<string>, parsedData?: Maybe<string>, parsedDataEn?: Maybe<string>, parsedDataRu?: Maybe<string>, downloadTime?: Maybe<any>, picsDownloaded: number, serviceData?: Maybe<string>, modelName?: Maybe<string> }>> }> };

export type StatsBidScoreQueryVariables = Exact<{
  companyEn: Scalars['String'];
  modelEn: Scalars['String'];
  modelTypeEn?: Maybe<Scalars['String']>;
  amount: Scalars['Long'];
  year: Scalars['Int'];
  ratingEn: Scalars['String'];
  mileage: Scalars['Long'];
}>;


export type StatsBidScoreQuery = { __typename?: 'Query', bidScore?: Maybe<number> };

export const AveragePriceByRatingDocument = gql`
    query averagePriceByRating($companyEn: String!, $modelEn: String!, $modelTypeEn: String) {
  averagePriceByRating: averagePrice(subgroup: "year-company-model-frame-rating-mileage", companyEn: $companyEn, modelEn: $modelEn, modelTypeEn: $modelTypeEn) {
    avg
    min
    max
    count
    score
    year
    mileageInterval
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AveragePriceByRatingGQL extends Apollo.Query<AveragePriceByRatingQuery, AveragePriceByRatingQueryVariables> {
    document = AveragePriceByRatingDocument;
    client = 'stats-auto';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JpCenterAutoLotDocument = gql`
    query jpCenterAutoLot($id: String!) {
  lot(id: $id) {
    lotId
    bid
    vin
    date
    time: datetime
    auctionName
    truckRef
    result
    company: companyEn
    companyRef
    modelName: modelNameEn
    modelNameRef
    modelGrade: modelGradeEn
    year: modelYearEn
    frame: modelTypeEn
    engineVolume: displacementNum
    equip: equipmentEn
    transmissionEn
    color: colorEn
    mileage: mileageEn
    rate: scoresEn
    startPrice: startPriceNum
    finishPrice: endPriceNum
    images: pictures
    inspection
    inspectionEn
    parsedData
    parsedDataEn
    parsedDataRu
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JpCenterAutoLotGQL extends Apollo.Query<JpCenterAutoLotQuery, JpCenterAutoLotQueryVariables> {
    document = JpCenterAutoLotDocument;
    client = 'stats-auto';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JpCenterLotsListFiltersDocument = gql`
    query jpCenterLotsListFilters($withModel: Boolean!, $filter: JpcenterAuctLotsFull3FilterInput, $sort: [JpcenterAuctLotsFull3SortInput!]) {
  frames(where: $filter, order: $sort) @include(if: $withModel) {
    name
    count
  }
  colors(where: $filter, order: $sort) @include(if: $withModel)
  scores(where: $filter, order: $sort)
  transmissions(where: $filter, order: $sort)
  auctions(where: $filter, order: $sort) {
    id
    name
  }
  companies {
    id
    name
  }
  models {
    id
    name
    companyId
    lotsCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JpCenterLotsListFiltersGQL extends Apollo.Query<JpCenterLotsListFiltersQuery, JpCenterLotsListFiltersQueryVariables> {
    document = JpCenterLotsListFiltersDocument;
    client = 'stats-auto';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JpCenterLotsListDocument = gql`
    query jpCenterLotsList($first: Int, $offset: Int, $filter: JpcenterAuctLotsFull3FilterInput, $sort: [JpcenterAuctLotsFull3SortInput!]) {
  lots: lotsPaginatedList(take: $first, skip: $offset, where: $filter, order: $sort) {
    items {
      lotId
      bid
      date
      time: datetime
      auctionName
      truckRef
      result
      companyEn
      modelNameEn
      modelGrade: modelGradeEn
      colorEn
      year: modelYearEn
      frame: modelTypeEn
      engineVolume: displacementNum
      equip: equipmentEn
      transmissionEn
      colorEn
      mileage: mileageEn
      rate: scoresEn
      startPrice: startPriceNum
      finishPrice: endPriceNum
      images: pictures
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JpCenterLotsListGQL extends Apollo.Query<JpCenterLotsListQuery, JpCenterLotsListQueryVariables> {
    document = JpCenterLotsListDocument;
    client = 'stats-auto';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotsDocument = gql`
    query lots($companyEn: String!, $modelEn: String!, $modelTypeEn: String, $filter: JpcenterAuctLotsFull3FilterInput, $subgroupByRating: String!, $subgroupByYear: String!) {
  averagePriceByRating: averagePrice(subgroup: $subgroupByRating, companyEn: $companyEn, modelEn: $modelEn, modelTypeEn: $modelTypeEn) {
    avg
    min
    max
    count
    score
    year
    mileageInterval
  }
  averagePriceByYear: averagePrice(subgroup: $subgroupByYear, companyEn: $companyEn, modelEn: $modelEn, modelTypeEn: $modelTypeEn) {
    avg
    min
    max
    count
    score
    year
  }
  years(where: $filter)
  frames(where: $filter) {
    name
  }
  scores(where: $filter)
  lotsPaginatedList(take: 20, where: $filter, order: [{displacedDatetime: DESC}]) {
    items {
      lotId
      date
      bid
      auctRef
      auctionName
      datetime
      company
      companyEn
      companyRef
      modelName: modelNameEn
      modelNameEn
      modelNameRef
      modelYear
      modelYearEn
      modelDetailsEn
      gradeEn
      modelGradeEn
      modelType
      modelTypeEn
      mileage
      mileageEn
      mileageNum
      inspection
      inspectionEn
      equipment
      equipmentEn
      transmission
      transmissionEn
      awdNum
      swType
      truckRef
      isSpecial
      displacement
      displacementNum
      startPrice
      startPriceNum
      endPrice
      endPriceNum
      color
      colorEn
      colorRef
      scores
      scoresEn
      result
      resultRef
      vin
      pictures
      parsedData
      parsedDataEn
      parsedDataRu
      downloadTime
      picsDownloaded
      serviceData
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotsGQL extends Apollo.Query<LotsQuery, LotsQueryVariables> {
    document = LotsDocument;
    client = 'stats-auto';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StatsBidScoreDocument = gql`
    query statsBidScore($companyEn: String!, $modelEn: String!, $modelTypeEn: String, $amount: Long!, $year: Int!, $ratingEn: String!, $mileage: Long!) {
  bidScore(amount: $amount, companyEn: $companyEn, modelEn: $modelEn, modelTypeEn: $modelTypeEn, year: $year, ratingEn: $ratingEn, mileage: $mileage)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StatsBidScoreGQL extends Apollo.Query<StatsBidScoreQuery, StatsBidScoreQueryVariables> {
    document = StatsBidScoreDocument;
    client = 'stats-auto';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    